import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { usePermission } from "../../hooks/usePermission";
import UserProfile from "../../assets/images/user_icon.png";
import { getRoleName } from "../../components/Utils";
import { PiCrown } from "react-icons/pi";
import SearchOverlay from "./SearchOverlay";
import NavbarClock from "./NavbarClock";
import "./Navbar.css";

const NavBar = () => {
  const [menuActive, setMenuActive] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const { hasPermission } = usePermission();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const auth_user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setMenuActive(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const openDrawer = () => {
    let html = document.querySelector("html");
    html.classList.add("layout-menu-expanded");
  };

  const toggleMenu = (e) => {
    e.stopPropagation();
    setMenuActive((prev) => !prev);
  };

  const closeMenu = () => setMenuActive(false);

  const logout = () => {
    closeMenu();
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
  };

  return (
    <nav
      className="layout-navbar navbar navbar-expand-xl align-items-center bg-navbar-theme navbar-padding"
      id="layout-navbar"
    >
      <div
        onClick={openDrawer}
        className="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none"
      >
        <i className="bx bx-menu bx-sm"></i>
      </div>

      {/* Search Bar - click to open overlay */}
      <div className="navbar-nav align-items-center">
        <div
          className="nav-item d-flex align-items-center custom-search-bar"
          onClick={() => setSearchOpen(true)}
          style={{ cursor: "pointer" }}
        >
          <i className="bx bx-search fs-4 lh-0"></i>
          <span className="search-placeholder-text">Search...</span>
        </div>
      </div>

      <NavbarClock />

      <div
        className="navbar-nav-right d-flex align-items-center justify-content-end"
        id="navbar-collapse"
      >
        <ul className="navbar-nav-icons">
          {/* <li>
            <a className="nav-icon-link" href="#" title="Dark Mode">
              <i className="bx bx-moon fs-4"></i>
            </a>
          </li>
          <li>
            <a className="nav-icon-link" href="#" title="Apps">
              <i className="bx bx-grid-alt fs-4"></i>
            </a>
          </li>
          <li>
            <a className="nav-icon-link" href="#" title="Notifications">
              <i className="bx bx-bell fs-4"></i>
              <span className="badge bg-danger rounded-pill badge-notifications">
                3
              </span>
            </a>
          </li>
          <li>
            <a className="nav-icon-link" href="#" title="Settings">
              <i className="bx bx-cog fs-4"></i>
            </a>
          </li>
          <li>
            <a className="nav-icon-link" href="#" title="History">
              <i className="bx bx-history fs-4"></i>
            </a>
          </li> */}
        </ul>

        {/* User Profile */}
        <div className="navbar-dropdown dropdown-user dropdown">
          <div className="user_icon">
            <div className="action" ref={dropdownRef}>
              <div className="navbar-user-trigger" onClick={toggleMenu}>
                {auth_user?.name && (
                  <div className="navbar-user-text">
                    <span className="navbar-user-greeting">
                      Hi, {auth_user.name}
                    </span>
                    <span className="navbar-user-role">
                      {getRoleName(auth_user?.user_type)}
                    </span>
                  </div>
                )}
                <div className="profile">
                  <img
                    src={UserProfile}
                    alt="icon"
                    className="rounded-circle"
                  />
                </div>
              </div>
              <div className={`menu ${menuActive ? "active" : ""}`}>
                <div className="profile_menu">
                  <div className="user_info">
                    <h5>{auth_user?.name}</h5>
                    <p>{auth_user?.email}</p>
                    <p>
                      {getRoleName(auth_user?.user_type)}{" "}
                      <PiCrown className="crown-icon" />
                    </p>
                  </div>
                  <div className="p_menu_list">
                    <ul>
                      <li>
                        <Link to="change-password" onClick={closeMenu}>
                          Change Password
                        </Link>
                      </li>
                      {/* {hasPermission("settings-list") && (
                        <li>
                          <Link to="/attendance-qr-code" onClick={closeMenu}>
                            Attendance QR Code
                          </Link>
                        </li>
                      )} */}
                      {/* {hasPermission("forum-settings-list") && (
                        <li>
                          <Link to="/forum-settings" onClick={closeMenu}>
                            Forum Settings
                          </Link>
                        </li>
                      )} */}
                    </ul>
                  </div>
                  <div className="profile_logout">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        logout();
                      }}
                    >
                      Logout
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Search Overlay */}
      <SearchOverlay isOpen={searchOpen} onClose={() => setSearchOpen(false)} />
    </nav>
  );
};

export default NavBar;
